
<!--
 * @Author: haifeng_xie haifeng_xie@kingdee.com
 * @Date: 2024-02-06 15:07:07
 * @LastEditors: haifeng_xie haifeng_xie@kingdee.com
 * @LastEditTime: 2024-07-19 14:16:18
 * @Description: 内容行
 'padding-left': (row.level * 20 < $store.state.width - 20)? (row.level * 20 + 10 + 'px'): ($store.state.width - 20 + 10 + 'px'),
-->
<template>
  <div
    class="row"
    :class="{
      'detail-show': $store.state.detailId == row.id,
      'searched': isSearched,
      'searched-act': isSearchedAct,
    }"    
    @contextmenu.prevent.stop="ContextmenuHandle($event, row)"
    @click="ShowDetail(row)"
  >
    <!-- 层级 -->
    <template v-for="(hLine, hIndex) in new Array(row.level)">
      <div
        :key="row.id + '-Lkey-' + hIndex"
        class="field-line"
        @click.stop
        :style="{
          'left': hIndex * 20 + 17 + 'px',
        }"
      ></div>
    </template>
    <!-- 行内 -->
    <div
      class="main-cell"      
      :style="{
        'padding-left': row.level * 20 + 10 + 'px',
      }"
    >
      <div class="main-cell-box">
        <!-- 折叠态 -->
        <i
          v-if="!row.isSealf"
          class="expand-icon"
          :class="{
            'el-icon-caret-bottom': !($store.state.expandMap[row.id]),
            'el-icon-caret-right': ($store.state.expandMap[row.id]),
          }"
          @click.stop="ChangeExpand(row.id)"
        ></i>
        <i
          v-else-if="row.isSealf"
          class="el-icon-location expand-icon task-info-label"
          @click.stop="LocationTask(row.id)"
        ></i>
        <!-- 选中态 -->
        <div
          v-if="$store.state.isCheckBoxShow"
          class="row-checkbox"
          @click.stop="Selected"
        >
          <div
            v-if="selectedShow"
            class="row-checkbox-status row-checkbox-status-checked"
          >
            <span></span><Icon class="el-icon-check"></Icon>
          </div>
          <div v-else class="row-checkbox-status"><span></span></div>
        </div>
        <!-- 前置Icon图标 -->
        <i
          v-if="iconList[row.iconIndex]"
          class="row-icon"
          :style="{'color': $store.state.themeColor}"
          :class="iconList[row.iconIndex]"
        ></i>
        <!-- 前置URL图片 -->
        <img
          v-if="($store.state.isIconImageShow && row.iconKey && iconMap && iconMap[row.iconKey])"
          class="row-img"
          :src="iconMap[row.iconKey]"
        />
        <!-- 名称 -->
        <span
          class="row-name"
        >{{ row.name }}</span>
      </div>
    </div>
    <!-- 动态单元格 -->
    <template v-if="(headers.length)">
      <template v-for="(col2, colIndex2) in row.cellList">
        <template v-if="(typeof headers[colIndex2] == 'object')">
          <div
            :key="headers[colIndex2].id + '&&' + col2.val"
            class="config-cell"
            :title='col2.val'
            :style="{
              'width': headers[colIndex2].colWidth + 'px',
              'font-size': headers[colIndex2].fontSize + 'px',
              'text-align': headers[colIndex2].colAlign,
            }"
          >
            {{ col2.val }}
          </div>
        </template>
      </template>
    </template>

  </div>
</template>
<script>
export default {
  name: "Row",
  data() {
    return {
      iconList: this.$const.ICON_LIST,
    };
  },
  props: {
    row: {
      type: Object,
      default: () => { return { name: "行名"}; },
    },
    activeSearchNum: {
      type: Number,
      default: () => { return 0; },
    },
    filteredArray: {
      type: Array,
      default: () => { return []; },
    },
  },
  methods: {
    ChangeExpand(rowId){
      this.$store.commit("set_expandMap", rowId);

    },
    Selected(){
      this.$store.commit("set_selectedArr", this.row);
    },
    ShowDetail(row){
      if(this.$store.state.detailId == row.id){
        return console.log("跳过、重复项");
      }
      this.$store.dispatch(this.$outConst.SELECT_ROW, row);
    },
    // 格式化右键菜单配置
    formatMenus(item, menuArr) {
      const _menus = [];
      if (menuArr instanceof Array && menuArr.length > 0) {
        const _self = this;
        for (let index = 0; index < menuArr.length; index++) {
          const element = menuArr[index];
          element.label = element.cbName;
          if (element.children instanceof Array && element.children.length > 0) {
            this.formatMenus(item, element.children);
          } else {
            element.onClick = () => {
              _self.$store._invoke(element.cbNumber, item);
            };
            delete element.children;
          }
          _menus.push(element);
        }
      }
      return _menus;
    },
    // 右键菜单
    ContextmenuHandle(event, item) {
      const _self = this;
      const _menus = item.menus;
      _menus instanceof Array &&
      _menus.length > 0 &&
      (() => {
        const items = _self.formatMenus(item, _menus);
        if (items.length > 0) {
          _self.$contextmenu({
            items,
            event,
            customClass: "list-row-class-hfx",
            zIndex: 5000,
            minWidth: 110,
          });
        }

      })();
    },
    
  },
  computed: {
    headers(){
      return this.$store.state.data.headers;
    },
    iconMap(){
      return this.$store.state.data.iconMap;
    },
    isSearched(){
      const _searchedFlag = this.filteredArray.filter(item => item.id == this.row.id);
      return (this.filteredArray.length > 0 && _searchedFlag.length > 0);
    },
    isSearchedAct(){
      const _activeIndex = this.activeSearchNum > 0? this.activeSearchNum: 0; // 兼容
      return (
        this.filteredArray.length > 0 &&
        this.filteredArray[_activeIndex] &&
        this.filteredArray[_activeIndex].id == this.row.id
      )
    },
    selectedShow(){
      if(!this.$store.state.isCheckBoxShow) return false;
      const selectedArr = this.$store.state.data.selectedArr;
      return selectedArr.includes(this.row.id);
    }
  }
}
</script>
<style scoped lang='less'>
@import './Row.less';

</style>
